const RETURN_KEY = 'onboardingSetupReturn';
const MAX_RETURN_AGE_MS = 60 * 60 * 1000;

export function rememberOnboardingOAuth({ onboarding, organizationId, provider, kind }) {
  sessionStorage.removeItem(RETURN_KEY);
  if (!onboarding || !organizationId) return;
  sessionStorage.setItem(RETURN_KEY, JSON.stringify({
    organizationId: String(organizationId), provider, kind, startedAt: Date.now(),
  }));
}

export function returnToOnboarding({ organizationId, provider, kind, success }) {
  let pending;
  try { pending = JSON.parse(sessionStorage.getItem(RETURN_KEY) || 'null'); }
  catch (_error) { sessionStorage.removeItem(RETURN_KEY); return false; }
  if (!pending) return false;
  if (!Number.isFinite(pending.startedAt) || Date.now() - pending.startedAt > MAX_RETURN_AGE_MS) {
    sessionStorage.removeItem(RETURN_KEY);
    return false;
  }
  if (pending.organizationId !== String(organizationId) || pending.provider !== provider || pending.kind !== kind) return false;
  sessionStorage.removeItem(RETURN_KEY);
  const params = new URLSearchParams({
    setupGoal: kind === 'calendar' ? 'appointment' : 'custom',
    setupStatus: success ? 'connected' : 'connection_failed',
    provider,
  });
  // Only a fixed local destination and non-sensitive status cross the handoff.
  window.location.replace(`/onboarding?${params.toString()}`);
  return true;
}
